import React from "react";
import { Link } from "react-router-dom";

function ReadMore({ navigateTo }) {
  console.log("whjat is navigateTo", navigateTo);
  return (
    <Link to={`${navigateTo}`} className="class-read-more">
      READ MORE
    </Link>
  );
}

export default ReadMore;
